/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnairePatientSccai {
  position: number;
  question: string;
  answers: string[];
}

export const Q_PATIENT_SCCAI: QuestionnairePatientSccai[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Quante evacuazioni ha avuto in media durante il giorno (cioè da quando si è svegliato a quando è andato a dormire) nell’ultima settimana? Vanno considerate anche le evacuazioni solo di muco o di sangue.' ,
    answers: [
      '0-3 evacuazioni',
      '4-6 evacuazioni',
      '7-9 evacuazioni',
      'oltre 9 evacuazioni'

]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 2, question: 'Quante evacuazioni ha avuto durante in media la notte (da quando si è coricato per dormire al risveglio, quante volte si è dovuto alzare per andare in bagno) nell’ultima settimana?',
    answers: [
      'nessuna',
      '1-3 evacuazioni',
      '3 o più evacuazioni'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Nell’ultima settimana, è stato in grado di trattenere le feci per 15 minuti o per più tempo, quando avverte l’urgenza di andare in bagno? (o a ad evacuare)',
    answers: [
      'Si',
      'No'/*,
      'Non lo so' Eliminato da richiesta*/
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Nell’ultima settimana, ha dovuto modificare le sue attività, per assicurarsi che ci sia un bagno nelle vicinanze?',
    answers: [
      'No',
      'Si'/*,
      'Non lo so' Eliminato da richiesta*/
    ]
  },
  {
    position: 5, question: 'Nell’ultima settimana, ha avuto episodi di incontinenza fecale?',
    answers: [
      'No',
      'Si'/*,
      'Non lo so' Eliminato da richiesta*/
    ]
  },
  {
    position: 6, question: 'Nell’ultima settimana, quante volte ha visto sangue nelle feci?',
    answers: [
      'Mai',
      'Molto meno della metà delle volte',
      'Un po\' meno della metà delle volte',
      'Più della metà delle volte'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 7, question: 'Se dovesse misurare il Suo stato di salute generale attribuendo un numero, quale numero sceglierebbe? (0=malissimo, 10=perfetto)',
    answers: [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10'
    ]
  },
  {
    position: 8, question: 'Nell’ultima settimana, ha avuto dolore articolare che peggiorava con il riposo piuttosto che con il movimento?',
    answers: [
      'No',
      'Si'/*,
      'Non lo so' Eliminato da richiesta*/
    ]
  },
  {
    position: 9, question: 'Nell’ultima settimana, ha avuto arrossamento o gonfiore articolare?',
    answers: [
      'No',
      'Si'/*,
      'Non lo so' Eliminato da richiesta*/
    ]
  },
  {
    position: 10, question: 'Nell’ultima settimana, si è mai svegliato per il dolore articolare?',
    answers: [
      'No',
      'Si'/*,
      'Non lo so' Eliminato da richiesta*/
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 11, question: 'Nell’ultima settimana, ha avuto un problema della cute che è stato diagnosticato come eritema nodoso dal Suo dermatologo? ',
    answers: [
      'No',
      'Si'/*,
      'Ho un problema della cute ma non ho consultato uno specialista o non conosco il nome del problema'*/
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 12, question: 'Nell’ultima settimana, ha avuto un problema della cute che è stato diagnosticato come pioderma gangrenoso dal Suo dermatologo',
    answers: [
      'No',
      'Si'/*,
      'Ho un problema della cute ma non ho consultato uno specialista o non conosco il nome del problema'*/
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 13, question: 'In questo momento è affetto da un’infezione oculare, per cui ha consultato un oculista ed è stata formulata la diagnosi di uveite?',
    answers: [
      'No',
      'Si'/*,
      'Ho un’infezione oculare ma non ho consultato un oculista o non conosco il nome dell’infezione'*/
    ]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class PatientSccaiResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }

}
